import React from 'react';
import { Icon } from "@iconify/react";
import mageDashboard from '../../assets/img/mage--dashboard.svg';
import location from '../../assets/img/location.svg';
import orderApproveOutlineRounded from '../../assets/img/material-symbols--order-approve-outline-rounded.svg';
import write from '../../assets/img/jam--write-f.svg';
import people24Filled from '../../assets/img/fluent--people-24-filled.svg';
import peopleCheckmark16Filled from '../../assets/img/fluent--people-checkmark-16-filled.svg';
import analytics from '../../assets/img/carbon--analytics.svg';

const SidebarItems = [
    {
        title: "Data Entry Clerk Dashboard",
        icon: <img src={mageDashboard} alt="dashboard" width="24" height="24" style={{ color: '#078ECE' }} />,
        path: "/data-entry/dashboard",
        roles: ["user"]
    },
    {
        title: "Recorded Data",
        icon: <img src={orderApproveOutlineRounded} alt="recorded data" width="24" height="24" style={{ color: '#078ECE' }} />,
        path: "/data-entry/recorded-data",
        roles: ["user"]
    },
    {
        title: "Coordinator Dashboard",
        icon: <img src={mageDashboard} alt="dashboard" width="24" height="24" style={{ color: '#078ECE' }} />,
        path: "/coordinator/dashboard",
        roles: ["coordinator"]
    },
    {
        title: "Coordinator Sectors",
        icon: <img src={location} alt="dashboard" width="24" height="24" style={{ color: '#078ECE' }} />,
        path: "/coordinator/sectors",
        roles: ["coordinator"]
    },
    {
        title: "Coordinator Approve Data",
        icon: <img src={orderApproveOutlineRounded} alt="approve data" width="24" height="24" style={{ color: '#078ECE' }} />,
        path: "/coordinator/approve-data",
        roles: ["coordinator"]
    },
    {
        title: "Coordinator Recorded Data",
        icon: <img src={write} alt="recorded data" width="24" height="24" style={{ color: '#078ECE' }} />,
        path: "/coordinator/indexed-books",
        roles: ["coordinator"]
    },
    {
        title: "Coordinator Scanner Operators",
        icon: <img src={people24Filled} alt="scanner operators" width="24" height="24" style={{ color: '#078ECE' }} />,
        path: "/coordinator/scanner-operators",
        roles: ["coordinator"]
    },
    {
        title: "Coordinator Analytics",
        icon: <img src={analytics} alt="analytics" width="24" height="24" style={{ color: '#078ECE' }} />,
        path: "/coordinator/analytics",
        roles: ["coordinator"]
    },
    {
        title: "Supervisor Dashboard",
        icon: <img src={mageDashboard} alt="dashboard" width="24" height="24" style={{ color: '#078ECE' }} />,
        path: "/supervisor/dashboard",
        roles: ["supervisor"]
    },
    {
        title: "Supervisor Scanned Data",
        icon: <img src={orderApproveOutlineRounded} alt="approve data" width="24" height="24" style={{ color: '#078ECE' }} />,
        path: "/supervisor/scanned-books",
        roles: ["supervisor"]
    },
    {
        title: "Supervisor Recorded Data",
        icon: <img src={write} alt="recorded data" width="24" height="24" style={{ color: '#078ECE' }} />,
        path: "/supervisor/indexed-books",
        roles: ["supervisor"]
    },
    {
        title: "Supervisor Analytics",
        icon: <img src={analytics} alt="analytics" width="24" height="24" style={{ color: '#078ECE' }} />,
        path: "/supervisor/analytics",
        roles: ["supervisor"]
    },
    
    {
        title: "Scanner Operator Dashboard",
        icon: <img src={mageDashboard} alt="dashboard" width="24" height="24" style={{ color: '#078ECE' }} />,
        path: "/scanner-operator/dashboard",
        roles: ["scanner-operator"]
    },
    {
        title: "Scanner Operator Recorded Data",
        icon: <img src={orderApproveOutlineRounded} alt="recorded data" width="24" height="24" style={{ color: '#078ECE' }} />,
        path: "/scanner-operator/recorded-data",
        roles: ["scanner-operator"]
    },
    {
        title: "Stakeholder Dashboard",
        icon: <img src={mageDashboard} alt="dashboard" width="24" height="24" style={{ color: '#078ECE' }} />,
        path: "/stakeholder/dashboard",
        roles: ["client"]
    },
    {
        title: "Admin Dashboard",
        icon: <img src={mageDashboard} alt="dashboard" width="24" height="24" style={{ color: '#078ECE' }} />,
        path: "/admin/dashboard",
        roles: ["admin"]
    },
    {
        title: "Admin Pending Users",
        icon: <img src={people24Filled} alt="pending users" width="24" height="24" style={{ color: '#078ECE' }} />,
        path: "/admin/pending-users",
        roles: ["admin"]
    },
    {
        title: "Scanner Assistant Dashboard",
        icon: <img src={mageDashboard} alt="dashboard" width="24" height="24" style={{ color: '#078ECE' }} />,
        path: "/scanner-assistant/dashboard",
        roles: ["scanner-assistant"]
    },
    {
        title: "Scanner Assistant Recorded Data",
        icon: <img src={orderApproveOutlineRounded} alt="recorded data" width="24" height="24" style={{ color: '#078ECE' }} />,
        path: "/scanner-assistant/recorded-data",
        roles: ["scanner-assistant"]
    },
    {
        title: "Admin Registered Users",
        icon: <img src={peopleCheckmark16Filled} alt="registered users" width="24" height="24" style={{ color: '#078ECE' }} />,
        path: "/admin/registered-users",
        roles: ["admin"]
    }

]

export default SidebarItems